import React from "react";

export const Background = () => {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden bg-[#05070b]">
      <div className="absolute inset-0 grid-bg" />
      <div
        className="glow-orb"
        style={{ width: 520, height: 520, top: -160, left: -120, background: "#00ff66" }}
      />
      <div
        className="glow-orb"
        style={{ width: 460, height: 460, top: 120, right: -140, background: "#00f0ff", opacity: 0.35 }}
      />
      <div
        className="glow-orb"
        style={{ width: 420, height: 420, bottom: -160, left: "40%", background: "#ff007a", opacity: 0.28 }}
      />
      <div className="absolute inset-0 grain" />
    </div>
  );
};
